export {
  ArticleFeaturedImage,
  type ArticleFeaturedImageProps,
} from "./ArticleFeaturedImage";
export { apiToArticleFeaturedImageProps } from "./apiToArticleFeaturedImageProps";
